// Translations for the Public Job Application page
export const translations = {
  en: {
    // Header
    companyName: 'ZonNet Digital Solutions',
    careerOpportunities: 'Career Opportunities',
    home: 'Home',
    menu: 'Menu',

    // Hero Section
    heroTitle: 'Application Form',
    heroSubtitle: 'Be part of a dynamic team that\'s shaping the future of digital solutions. Apply now and start your journey with us!',

    // Form Sections
    personalInfo: 'Personal Information',
    personalInfoSubtitle: 'Tell us about yourself',
    positionSource: 'Position & Source',
    positionSourceSubtitle: 'Which position interests you?',
    documents: 'Required Documents',
    requiredDocuments: 'Required Documents',
    requiredDocumentsSubtitle: 'Upload your CV and optional photo',

    // Form Fields
    fullName: 'Full Name',
    fullNamePlaceholder: 'Enter your full legal name',
    fullNameHelper: 'Enter your full name as it appears on official documents',
    email: 'Email Address',
    emailPlaceholder: 'your.email@example.com',
    emailHelper: 'We\'ll send updates to this email',
    phone: 'Phone Number',
    phonePlaceholder: '01234567890',
    phoneHelper: '10-15 digits',
    positionAppliedFor: 'Position Applied For',
    howHeard: 'How did you hear about us?',
    pleaseSpecify: 'Please Specify',
    pleaseSpecifyPlaceholder: 'Tell us how you found this opportunity',
    referralName: 'Referral Name',
    referralNamePlaceholder: 'Enter the name of the person who referred you',
    referralNameHelper: 'Full name of the person who referred you',
    message: 'Cover Note / Message (Optional)',
    messagePlaceholder: 'Tell us why you\'re interested in this position and what makes you a great fit... (Optional)',
    coverNote: 'Cover Note / Message (Optional)',
    coverNotePlaceholder: 'Tell us why you\'re interested in this position and what makes you a great fit... (Optional)',
    characters: 'characters',
    charactersCount: 'characters',

    // How Heard Options
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    friend: 'Friend / Referral',
    website: 'Website',
    jobBoard: 'Job Board',
    other: 'Other',

    // File Upload
    uploadCV: 'Upload Your CV',
    dropCV: 'Drop Your CV Here',
    dragOrClick: 'Drag & drop or click to browse',
    dragDropOrClick: 'Drag & drop or click to browse',
    releaseToUpload: 'Release to upload',
    cvUploadSuccess: 'CV Uploaded Successfully!',
    cvUploaded: 'CV Uploaded Successfully!',
    size: 'Size',
    fileSize: 'Size',
    removeFile: 'Remove File',
    maxSize: 'Max 5MB',
    profilePicture: 'Profile Picture',
    optional: 'Optional',
    uploadPhoto: 'Upload a professional photo to enhance your profile',
    profilePictureHelper: 'Upload a professional photo to enhance your profile',
    clickToChange: 'Click to change your photo',
    uploading: 'Uploading...',

    // File Requirements
    fileRequirements: 'File Requirements',
    cvRequirements: 'CV: PDF, DOC, or DOCX files up to 5MB',
    photoRequirements: 'Photo: JPG, PNG, or WEBP images up to 2MB',

    // Consent
    consentText: 'I consent to the collection and processing of my personal data for recruitment purposes only.',
    viewPrivacyPolicy: 'View full privacy policy',
    privacyPolicyTitle: 'Privacy Policy & Data Consent',
    dataCollection: 'Data Collection & Usage',
    dataCollectionDesc: 'By submitting this application, you consent to ZonNet Digital Solutions collecting and processing your personal information for recruitment purposes. This includes:',
    dataCollectionText: 'By submitting this application, you consent to ZonNet Digital Solutions collecting and processing your personal information for recruitment purposes. This includes:',
    personalContact: 'Personal contact information (name, email, phone number)',
    professionalDocs: 'Professional documents (CV, cover letter, portfolio)',
    applicationDetails: 'Application details and communication history',
    yourRights: 'Your Rights',
    yourRightsDesc: 'You have the right to access, correct, or request deletion of your personal data at any time by contacting our HR department at info@z0n.net.',
    yourRightsText: 'You have the right to access, correct, or request deletion of your personal data at any time by contacting our HR department at info@z0n.net.',
    iUnderstand: 'I Understand',
    understand: 'I Understand',

    // Submit
    submitApplication: 'Submit Application',
    submitting: 'Submitting Application...',
    submittingApplication: 'Submitting Application...',
    mustAgreeConsent: 'You must agree to the data processing consent to submit',

    // Success
    applicationSubmitted: 'Application Submitted Successfully!',
    referenceNumber: 'Reference',
    thankYou: 'Thank you for applying to',
    applicationReceived: 'We\'ve received your application and our HR team will carefully review it.',
    whatNext: 'What happens next?',
    applicationReview: 'Application Review',
    applicationReviewTime: 'Within 3-5 business days',
    initialScreening: 'Initial Screening',
    initialScreeningDesc: 'Phone/Video interview if qualified',
    finalDecision: 'Final Decision',
    finalDecisionDesc: 'You\'ll receive an email update',
    submitAnother: 'Submit Another Application',
    backToHome: 'Back to Home',

    // Footer
    companyDescription: 'Leading provider of innovative digital solutions, helping businesses transform and grow in the digital age.',
    aboutUs: 'Leading provider of innovative digital solutions, helping businesses transform and grow in the digital age.',
    contactUs: 'Contact Us',
    followUs: 'Follow Us',
    privacyPolicy: 'Privacy Policy',
    termsConditions: 'Terms & Conditions',
    copyright: '© 2025 ZonNet Digital Solutions. All rights reserved.',

    // Job Details
    jobDetails: 'Job Details',
    jobDescription: 'Job Description',
    viewFullDescription: 'View full job description',
    close: 'Close',

    // Loading & Errors
    loadingPositions: 'Loading available positions...',
    failedToLoad: 'Failed to load available positions',
    retry: 'Retry',
    noJobsAvailable: 'No positions available at the moment',

    // Validation
    required: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number',
    selectPosition: 'Please select a position',
    uploadCVRequired: 'Please upload your CV',
    fillRequired: 'Please fill in all required fields correctly',
    fileTooLarge: 'File size must be less than',
    invalidFileType: 'Invalid file type. Please upload',
    cvSuccess: 'CV uploaded successfully!',
    photoSuccess: 'Profile picture uploaded successfully!',
  },

  ar: {
    // Header
    companyName: 'زون نت للحلول الرقمية',
    careerOpportunities: 'الفرص الوظيفية',
    home: 'الرئيسية',
    menu: 'القائمة',

    // Hero Section
    heroTitle: 'انضم إلى فريقنا المبتكر',
    heroSubtitle: 'كن جزءًا من فريق ديناميكي يشكل مستقبل الحلول الرقمية. تقدم الآن وابدأ رحلتك معنا!',

    // Form Sections
    personalInfo: 'المعلومات الشخصية',
    personalInfoSubtitle: 'أخبرنا عن نفسك',
    positionSource: 'الوظيفة والمصدر',
    positionSourceSubtitle: 'ما الوظيفة التي تهمك؟',
    documents: 'المستندات المطلوبة',
    requiredDocuments: 'المستندات المطلوبة',
    requiredDocumentsSubtitle: 'ارفع سيرتك الذاتية وصورة اختيارية',

    // Form Fields
    fullName: 'الاسم الكامل',
    fullNamePlaceholder: 'أدخل اسمك القانوني الكامل',
    fullNameHelper: 'أدخل اسمك الكامل كما يظهر في المستندات الرسمية',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'your.email@example.com',
    emailHelper: 'سنرسل التحديثات إلى هذا البريد',
    phone: 'رقم الهاتف',
    phonePlaceholder: '01234567890',
    phoneHelper: '10-15 رقم',
    positionAppliedFor: 'الوظيفة المتقدم لها',
    howHeard: 'كيف سمعت عنا؟',
    pleaseSpecify: 'يرجى التوضيح',
    pleaseSpecifyPlaceholder: 'أخبرنا كيف وجدت هذه الفرصة',
    referralName: 'اسم المُحيل',
    referralNamePlaceholder: 'أدخل اسم الشخص الذي أحالك',
    referralNameHelper: 'الاسم الكامل للشخص الذي أحالك',
    message: 'رسالة تغطية / ملاحظة (اختياري)',
    messagePlaceholder: 'أخبرنا لماذا أنت مهتم بهذه الوظيفة وما الذي يجعلك مناسبًا لها... (اختياري)',
    coverNote: 'رسالة تغطية / ملاحظة (اختياري)',
    coverNotePlaceholder: 'أخبرنا لماذا أنت مهتم بهذه الوظيفة وما الذي يجعلك مناسبًا لها... (اختياري)',
    characters: 'حرف',
    charactersCount: 'حرف',

    // How Heard Options
    facebook: 'فيسبوك',
    linkedin: 'لينكد إن',
    friend: 'صديق / إحالة',
    website: 'الموقع الإلكتروني',
    jobBoard: 'موقع توظيف',
    other: 'أخرى',

    // File Upload
    uploadCV: 'ارفع سيرتك الذاتية',
    dropCV: 'أفلت سيرتك الذاتية هنا',
    dragOrClick: 'اسحب وأفلت أو انقر للتصفح',
    dragDropOrClick: 'اسحب وأفلت أو انقر للتصفح',
    releaseToUpload: 'أفلت للرفع',
    cvUploadSuccess: 'تم رفع السيرة الذاتية بنجاح!',
    cvUploaded: 'تم رفع السيرة الذاتية بنجاح!',
    size: 'الحجم',
    fileSize: 'الحجم',
    removeFile: 'إزالة الملف',
    maxSize: 'الحد الأقصى 5 ميجابايت',
    profilePicture: 'الصورة الشخصية',
    optional: 'اختياري',
    uploadPhoto: 'ارفع صورة احترافية لتعزيز ملفك الشخصي',
    profilePictureHelper: 'ارفع صورة احترافية لتعزيز ملفك الشخصي',
    clickToChange: 'انقر لتغيير صورتك',
    uploading: 'جارٍ الرفع...',

    // File Requirements
    fileRequirements: 'متطلبات الملف',
    cvRequirements: 'السيرة الذاتية: ملفات PDF أو DOC أو DOCX حتى 5 ميجابايت',
    photoRequirements: 'الصورة: صور JPG أو PNG أو WEBP حتى 2 ميجابايت',

    // Consent
    consentText: 'أوافق على جمع ومعالجة بياناتي الشخصية لأغراض التوظيف فقط.',
    viewPrivacyPolicy: 'عرض سياسة الخصوصية الكاملة',
    privacyPolicyTitle: 'سياسة الخصوصية وموافقة البيانات',
    dataCollection: 'جمع واستخدام البيانات',
    dataCollectionDesc: 'من خلال إرسال هذا الطلب، فإنك توافق على قيام زون نت للحلول الرقمية بجمع ومعالجة معلوماتك الشخصية لأغراض التوظيف. وهذا يشمل:',
    dataCollectionText: 'من خلال إرسال هذا الطلب، فإنك توافق على قيام زون نت للحلول الرقمية بجمع ومعالجة معلوماتك الشخصية لأغراض التوظيف. وهذا يشمل:',
    personalContact: 'معلومات الاتصال الشخصية (الاسم، البريد الإلكتروني، رقم الهاتف)',
    professionalDocs: 'المستندات المهنية (السيرة الذاتية، خطاب التغطية، الملف الشخصي)',
    applicationDetails: 'تفاصيل الطلب وسجل الاتصالات',
    yourRights: 'حقوقك',
    yourRightsDesc: 'لديك الحق في الوصول إلى بياناتك الشخصية أو تصحيحها أو طلب حذفها في أي وقت من خلال الاتصال بقسم الموارد البشرية لدينا على info@z0n.net.',
    yourRightsText: 'لديك الحق في الوصول إلى بياناتك الشخصية أو تصحيحها أو طلب حذفها في أي وقت من خلال الاتصال بقسم الموارد البشرية لدينا على info@z0n.net.',
    iUnderstand: 'فهمت',
    understand: 'فهمت',

    // Submit
    submitApplication: 'إرسال الطلب',
    submitting: 'جارٍ إرسال الطلب...',
    submittingApplication: 'جارٍ إرسال الطلب...',
    mustAgreeConsent: 'يجب الموافقة على معالجة البيانات للإرسال',

    // Success
    applicationSubmitted: 'تم إرسال الطلب بنجاح!',
    referenceNumber: 'الرقم المرجعي',
    thankYou: 'شكرًا لتقديمك طلب التوظيف إلى',
    applicationReceived: 'لقد استلمنا طلبك وسيقوم فريق الموارد البشرية لدينا بمراجعته بعناية.',
    whatNext: 'ماذا بعد؟',
    applicationReview: 'مراجعة الطلب',
    applicationReviewTime: 'في غضون 3-5 أيام عمل',
    initialScreening: 'الفحص الأولي',
    initialScreeningDesc: 'مقابلة هاتفية/فيديو إذا كنت مؤهلاً',
    finalDecision: 'القرار النهائي',
    finalDecisionDesc: 'ستتلقى تحديثًا عبر البريد الإلكتروني',
    submitAnother: 'إرسال طلب آخر',
    backToHome: 'العودة إلى الصفحة الرئيسية',

    // Footer
    companyDescription: 'مزود رائد للحلول الرقمية المبتكرة، نساعد الشركات على التحول والنمو في العصر الرقمي.',
    aboutUs: 'مزود رائد للحلول الرقمية المبتكرة، نساعد الشركات على التحول والنمو في العصر الرقمي.',
    contactUs: 'اتصل بنا',
    followUs: 'تابعنا',
    privacyPolicy: 'سياسة الخصوصية',
    termsConditions: 'الشروط والأحكام',
    copyright: '© 2025 زون نت للحلول الرقمية. جميع الحقوق محفوظة.',

    // Job Details
    jobDetails: 'تفاصيل الوظيفة',
    jobDescription: 'وصف الوظيفة',
    viewFullDescription: 'عرض الوصف الكامل للوظيفة',
    close: 'إغلاق',

    // Loading & Errors
    loadingPositions: 'جارٍ تحميل الوظائف المتاحة...',
    failedToLoad: 'فشل تحميل الوظائف المتاحة',
    retry: 'إعادة المحاولة',
    noJobsAvailable: 'لا توجد وظائف متاحة في الوقت الحالي',

    // Validation
    required: 'هذا الحقل مطلوب',
    invalidEmail: 'يرجى إدخال عنوان بريد إلكتروني صحيح',
    invalidPhone: 'يرجى إدخال رقم هاتف صحيح',
    selectPosition: 'يرجى اختيار وظيفة',
    uploadCVRequired: 'يرجى رفع سيرتك الذاتية',
    fillRequired: 'يرجى ملء جميع الحقول المطلوبة بشكل صحيح',
    fileTooLarge: 'يجب أن يكون حجم الملف أقل من',
    invalidFileType: 'نوع ملف غير صحيح. يرجى رفع',
    cvSuccess: 'تم رفع السيرة الذاتية بنجاح!',
    photoSuccess: 'تم رفع الصورة الشخصية بنجاح!',
  }
};
